export default __webpack_public_path__ + "static/media/Map.3833cf24.svg";